import { cn } from "@/lib/utils";

export default function Tags({ className, children }: { className?: string; children: React.ReactNode }) {
	return <div className={cn("flex gap-4 items-center", className)}>{children}</div>;
}
